export class Point
{
    constructor(public x:number,
                public y:number)
    {
    }

    public static from(x:number, y:number):Point
    {
        return new Point(x, y);
    }

    public static zero()
    {
        return new Point(0, 0);
    }

    toString()
    {
        return `${this.x},${this.y}`;
    }
}
